import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HeaderToggleI } from '../_models/header_objects';

@Injectable({
    providedIn: 'root'
})
export class HeaderService {

    constructor(private http: HttpClient) { }

    private dataSubject = new BehaviorSubject<any>(null); // Use BehaviorSubject for initial value
    data$ = this.dataSubject.asObservable();
    
    sendData(data: any) {
        this.dataSubject.next(data);
    }

    fetchToggle(): Observable<HeaderToggleI> {
        return this.http.get<HeaderToggleI>(environment.apiUrl + `/users/loginuser`);
    }

    getLoginUserInfo(): Observable<HeaderToggleI> {
        return this.http.get<HeaderToggleI>(environment.apiUrl + `/users/get/loginuserinfo`);
    }

    setToggle(payload: any): Observable<HeaderToggleI> {
        return this.http.post<HeaderToggleI>(environment.apiUrl + `/users/${payload['id']}`, payload);
    }
}
